import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetRedirectAreaHistorical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { REDIRECT_AREA } from '../../../../../routes/paths';

export const useRedirectAreaDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idRedirectArea } = useParams();
    const [loading, setLoading] = useState(false);
    const [redirectArea, setRedirectArea] = useState<Param>();
    const [redirectAreaHistorical, setRedirectAreaHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idRedirectArea)) {
            setLoading(true);
            asyncGetParam(idRedirectArea)
                .then((redirectArea: any) => {
                    if (!redirectArea || !redirectArea.items)
                        navigate(REDIRECT_AREA);
                    setRedirectArea(redirectArea?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idRedirectArea]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetRedirectAreaHistorical(idRedirectArea)
                .then((resp) => {
                    if (resp) setRedirectAreaHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        redirectArea,
        redirectAreaHistorical,
        showHistorical,
        setShowHistorical,
    };
};
